import { useTranslations } from '@vocab/react';
import { Alert, List, Stack, Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

interface ManageCandidateApplicationsSectionAlertProps {
  hasLinkOutEnabled?: boolean;
  hasQuestionnaireUrl?: boolean;
}

export const ManageCandidateApplicationsSectionAlert = ({
  hasLinkOutEnabled,
  hasQuestionnaireUrl,
}: ManageCandidateApplicationsSectionAlertProps) => {
  const { t } = useTranslations(translations);
  return (
    <>
      {!hasLinkOutEnabled && hasQuestionnaireUrl && (
        <Alert tone="info" data={{ testid: 'manage-edit-section-alert' }}>
          <Text>
            {t('manage-candidate-applications-section-alert-rr-only-text')}
          </Text>
        </Alert>
      )}

      {hasLinkOutEnabled && !hasQuestionnaireUrl && (
        <Alert tone="info" data={{ testid: 'manage-edit-section-alert' }}>
          <Text>
            {t('manage-candidate-applications-section-alert-linkout-only-text')}
          </Text>
        </Alert>
      )}

      {hasLinkOutEnabled && hasQuestionnaireUrl && (
        <Alert tone="info" data={{ testid: 'manage-edit-section-alert' }}>
          <Stack space="large">
            <Text>
              {t(
                'manage-candidate-applications-section-alert-rr-and-linkout-text',
              )}
            </Text>
            <List space="medium">
              <Text>
                {t(
                  'manage-candidate-applications-section-alert-rr-and-linkout-list-text1',
                )}
              </Text>
              <Text>
                {t(
                  'manage-candidate-applications-section-alert-rr-and-linkout-list-text2',
                )}
              </Text>
            </List>
          </Stack>
        </Alert>
      )}
    </>
  );
};
